import React from "react"
import { Button, Form, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

interface IMessageModalForm {
    modalActive: boolean;
    modalTitle: string;
    modalDescription: string;
    message?: string | undefined;
    largeView?: boolean;
    onConfirm: (isConfirm: boolean, message?: string) => void;
}

export default function MessageModalForm({ modalActive, modalTitle, modalDescription, message, largeView, onConfirm }: IMessageModalForm) {
    const [currentMessage, setCurrentMessage] = React.useState<string>(message || "");

    function onConfirmButtonClick() {
        onConfirm(true, currentMessage);
    }

    function onCancelButtonClick() {
        onConfirm(false, message || "");
    }

    return (
        <Modal isOpen={modalActive} toggle={() => { onConfirm(false); }} size={largeView ? "lg" : "md"} >
            <ModalHeader toggle={() => { onConfirm(false); }}>{modalTitle}</ModalHeader>
            <ModalBody>
                <Form>
                    <div><Label>{modalDescription}</Label></div>
                    {largeView && <textarea className="form-control" id="exampleFormControlTextarea1" rows={10}
                        defaultValue={message} onChange={(e) => { setCurrentMessage(e.target.value) }}></textarea>}
                    {!largeView &&
                        <Input type="text" className="form-control" defaultValue={message}
                            onChange={(e) => { setCurrentMessage(e.target.value) }} />}
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" disabled={!currentMessage} onClick={onConfirmButtonClick}>Ok</Button>{" "}
                <Button color="secondary" onClick={onCancelButtonClick}>Cancel</Button>
            </ModalFooter>
        </Modal>
    )
}
